document.addEventListener('alpine:init', () => {
    Alpine.store('filters', {
      // Initialize from session storage, default to false (closed)
      show: sessionStorage.getItem('filters_open') === 'true',
      
      toggle() {
        this.show = !this.show
        // Persist to session storage
        sessionStorage.setItem('filters_open', this.show)
        console.log('Filters toggled:', this.show)
      },
      
      close() {
        this.show = false
        sessionStorage.setItem('filters_open', 'false')
      },
      
      open() {
        this.show = true
        sessionStorage.setItem('filters_open', 'true')
      }
    })
  })